import React, { ReactElement, useEffect } from "react";
import { useFormikContext, ErrorMessage, Field } from "formik";
import { RadioButton } from "primereact/radiobutton";
import ExtendedLabel from "../../extendedLabel/extendedLabel";

interface RadioOption {
  label?: string;
  value: any;
  extendedlabel?: string | ReactElement;
  hideExpression?: (formContext: any) => boolean;
}

const RadioButtonComponent: React.FC<any> = (props) => {
  const { name, label, extendedlabel, options, warn, errorRequired = true, Body, isRequired, context, ...rest } = props;
  const { setFieldTouched, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (!isSubmitting) return;
    setFieldTouched(name, true, true);
  }, [isSubmitting, name, setFieldTouched]);

  return (
    <div className={`w-full flex flex-col contextChildTable`} id={name.split(".").pop()}>
      <div className="extentedlabel-container">
        {label && (
          <label htmlFor={name} className={isRequired ? "isRequired mb-2" : "mb-2"}>
            {label}
          </label>
        )}
        {Body && <Body />}

        {extendedlabel && <ExtendedLabel text={extendedlabel} />}
      </div>
      <div className="flex flex-col">
        <Field name={name}>
          {({ field, form }: any) => (
            <>
              {options.map(
                (option: RadioOption) =>
                  (!option.hideExpression || !option.hideExpression(context)) && (
                    <div key={String(option.value)}>
                      <div className={`flex items-baseline flex-row ${rest.fieldclassname ?? ""}`}>
                        <RadioButton
                          className="cursor-pointer radio-btn"
                          {...field}
                          {...rest}
                          inputId={`${name}_${String(option.value)}`}
                          value={option.value}
                          checked={field.value === option.value}
                          onChange={(e) => {
                            setFieldTouched(name, true, true);
                            form.setFieldValue(name, e.value);
                          }}
                        />
                        {option.label && (
                          <div>
                            <label htmlFor={`${name}_${String(option.value)}`} className="mx-2 mt-0!">
                              {option.label}
                            </label>
                          </div>
                        )}
                      </div>
                      {option.extendedlabel && (
                        <div className="fieldadv">
                          <i>{option.extendedlabel}</i>
                        </div>
                      )}
                    </div>
                  )
              )}
            </>
          )}
        </Field>
      </div>
      {warn && <div className=" text-left fieldadv">{warn}</div>}
      {errorRequired && <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />}
    </div>
  );
};

export default RadioButtonComponent;
